import {useTranslation} from 'react-i18next';
import GenericDialog from '../Dialog/GenericDialog';
import {Stack, styled, Typography} from '@mui/material';

const ContactTypographyStyled = styled(Typography)({
    fontFamily: 'BNPPSans',
    fontWeight: '400',
    lineHeight: '1.33',
    color: '#00915a'
});

const ContactModal = ({isOpenContactDialog, setIsOpenContactDialog}: {
    isOpenContactDialog: boolean,
    setIsOpenContactDialog: (isOpenContactDialog: boolean) => void
}) => {
    const {t} = useTranslation(['commons']);

    return <GenericDialog
        isOpen={isOpenContactDialog}
        title={t('commons:modules.webpro.footer.contact-dialog.title')}
        handleClose={() => setIsOpenContactDialog(false)}>

        <Stack alignItems='left'>
            <Typography variant='h1' align='left' marginBottom='15px' marginTop='15px'
                        fontWeight='400'>
                {t('commons:modules.webpro.footer.contact-dialog.client-service')}
            </Typography>
            <Typography variant='h5' align='left' marginBottom='15px'>
                {t('commons:modules.webpro.footer.contact-dialog.availability')}
            </Typography>
            <ContactTypographyStyled variant='h1' align='left'>
                {t('commons:modules.webpro.footer.contact-dialog.phone-number')}
            </ContactTypographyStyled>
        </Stack>
    </GenericDialog>;
};

export default ContactModal;
